import { LIBERTY_IMAGES } from '../assets/asset';

/** Quote leg for the public USDC ↔ X swap UI (icons + chain badge). */
export const QUOTE_TOKENS_BY_ID = {
  usdc: {
    id: 'usdc',
    symbol: 'USDC',
    label: 'USDC',
    tokenSrc: LIBERTY_IMAGES.USDC,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  pls: {
    id: 'pls',
    symbol: 'PLS',
    label: 'PLS',
    tokenSrc: LIBERTY_IMAGES.PLS,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  weth: {
    id: 'weth',
    symbol: 'WETH',
    label: 'WETH',
    tokenSrc: LIBERTY_IMAGES.ETH,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  plsx: {
    id: 'plsx',
    symbol: 'PLSX',
    label: 'PLSX',
    tokenSrc: LIBERTY_IMAGES.PLSX,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  hex: {
    id: 'hex',
    symbol: 'HEX',
    label: 'HEX',
    tokenSrc: LIBERTY_IMAGES.HEX,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  inc: {
    id: 'inc',
    symbol: 'INC',
    label: 'INC',
    tokenSrc: LIBERTY_IMAGES.INC,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  pcock: {
    id: 'pcock',
    symbol: 'PCOCK',
    label: 'PCOCK',
    tokenSrc: LIBERTY_IMAGES.PCOCK,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  pdai: {
    id: 'pdai',
    symbol: 'pDAI',
    label: 'pDAI',
    tokenSrc: LIBERTY_IMAGES.PDAI,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  ehex: {
    id: 'ehex',
    symbol: 'eHEX',
    label: 'eHEX',
    tokenSrc: LIBERTY_IMAGES.EHEX,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
  prvx: {
    id: 'prvx',
    symbol: 'PRVX',
    label: 'PRVX',
    tokenSrc: LIBERTY_IMAGES.PRVX,
    chainSrc: LIBERTY_IMAGES.PULSECHAIN,
    chainName: 'PulseChain',
  },
};

/** Order of chips under “Top pair”, matching the original layout. */
export const TOP_PAIR_TOKEN_IDS = [
  'usdc',
  'pls',
  'weth',
  'plsx',
  'hex',
  'inc',
  'pcock',
  'pdai',
  'ehex',
  'prvx',
];

/** Rows for token picker modals (id + display fields). */
export function getSwappableTokenList() {
  return TOP_PAIR_TOKEN_IDS.map((id) => ({ id, ...QUOTE_TOKENS_BY_ID[id] }));
}
